import React from 'react'
import "./home.css"

const ScrollDown = () => {
  return (
    <div className="home__scroll">
        <a href="#about" className="home__scroll-button button--flex" aria-label="Scroll down to About section">
          <div className="home__scroll-content">
            <div className="home__scroll-mouse-container">
              <div className="home__scroll-mouse">
                <div className="home__scroll-wheel"></div>
              </div>
            </div>
            <span className="home__scroll-name">Scroll Down</span>
            <i className="uil uil-arrow-down home__scroll-arrow" aria-hidden="true"></i>
          </div>
        </a>
    </div>
  )
}

export default ScrollDown

